// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setFormIfValueIsDefined = (formData: FormData, key: string, value: any) => {
  if (value) {
    formData.append(key, value);
  }
};
